const primaryColors = {
  white: '#ffffff',
  black: '#000000',
  orange: '#ff6500'
}

const whiteShades = {
  shade1: '#b2b2b2',
  shade2: '#808080',
  shade3: '#666666',
  shade4: '#4d4d4d'
}

const orangeShades = {
  shade1: '#b24700',
  shade2: '#803300',
  shade3: '#662800',
  shade4: '#4d1e00'
}

const buttonWhite = {
  contained: {
    font: primaryColors.black,
    background: primaryColors.white,
    backgroundHover: whiteShades.shade1,
    backgroundActive: whiteShades.shade2,
    backgroundDisabled: whiteShades.shade3
  },
  outlined: {
    font: primaryColors.white,
    background: 'transparent',
    border: whiteShades.shade1,
    backgroundHover: whiteShades.shade4,
    borderHover: primaryColors.white,
    backgroundActive: whiteShades.shade2,
    borderActive: primaryColors.white,
    fontDisabled: whiteShades.shade3,
    borderDisabled: whiteShades.shade2
  },
  text: {
    background: 'transparent',
    font: primaryColors.white,
    fontHover: whiteShades.shade1,
    fontActive: whiteShades.shade2,
    fontDisabled: whiteShades.shade3
  }
}

const buttonOrange = {
  contained: {
    font: primaryColors.black,
    background: primaryColors.orange,
    backgroundHover: orangeShades.shade1,
    backgroundActive: orangeShades.shade2,
    backgroundDisabled: orangeShades.shade3
  },
  outlined: {
    font: primaryColors.orange,
    background: 'transparent',
    border: orangeShades.shade1,
    backgroundHover: orangeShades.shade4,
    borderHover: primaryColors.orange,
    backgroundActive: orangeShades.shade2,
    borderActive: primaryColors.orange,
    fontDisabled: orangeShades.shade3,
    borderDisabled: orangeShades.shade2
  },
  text: {
    background: 'transparent',
    font: primaryColors.orange,
    fontHover: orangeShades.shade1,
    fontActive: orangeShades.shade2,
    fontDisabled: orangeShades.shade3
  }
}

const transparentColors = {
  transparent: 'rgba(0, 0, 0, 0)',

  whiteShade1: 'rgba(255, 255, 255, 0.1)',
  whiteShade2: 'rgba(255, 255, 255, 0.2)',
  whiteShade3: 'rgba(255, 255, 255, 0.3)',
  whiteShade4: 'rgba(255, 255, 255, 0.4)',
  whiteShade5: 'rgba(255, 255, 255, 0.5)',
  whiteShade6: 'rgba(255, 255, 255, 0.6)',

  blackShade1: 'rgba(0, 0, 0, 0.1)',
  blackShade2: 'rgba(0, 0, 0, 0.2)',
  blackShade3: 'rgba(0, 0, 0, 0.3)',
  blackShade4: 'rgba(0, 0, 0, 0.4)',
  blackShade5: 'rgba(0, 0, 0, 0.5)',
  blackShade6: 'rgba(0, 0, 0, 0.6)',
  blackShade7: 'rgba(0, 0, 0, 0.7)',
  blackShade8: 'rgba(0, 0, 0, 0.8)',

  orangeShade1: 'rgba(255, 101, 0, 0.1)',
  orangeShade2: 'rgba(255, 101, 0, 0.2)',
  orangeShade3: 'rgba(255, 101, 0, 0.3)',
  orangeShade4: 'rgba(255, 101, 0, 0.4)',
  orangeShade5: 'rgba(255, 101, 0, 0.5)',
  orangeShade6: 'rgba(255, 101, 0, 0.6)'
}

const iconButtonWhite = {
  font: primaryColors.white,
  background: transparentColors.whiteShade3,
  backgroundHover: transparentColors.whiteShade4,
  backgroundActive: transparentColors.whiteShade5
}

const iconButtonBlack = {
  font: primaryColors.black,
  background: transparentColors.blackShade3,
  backgroundHover: transparentColors.blackShade4,
  backgroundActive: transparentColors.blackShade5
}

const iconButtonBlackText = {
  font: primaryColors.black,
  background: transparentColors.transparent,
  fontHover: transparentColors.blackShade6,
  fontActive: transparentColors.blackShade5
}

const iconButtonWhiteText = {
  font: primaryColors.white,
  background: transparentColors.transparent,
  fontHover: transparentColors.whiteShade6,
  fontActive: transparentColors.whiteShade5
}

export {
  primaryColors,
  whiteShades,
  orangeShades,
  buttonWhite,
  buttonOrange,
  transparentColors,
  iconButtonWhite,
  iconButtonBlack,
  iconButtonBlackText,
  iconButtonWhiteText
}
